import React, { createContext, useContext, useState, ReactNode, useCallback } from 'react';

interface ComponentRegistryContextType {
    componentRegistry: Record<string, ReactNode>;
    registerComponent: (name: string, component: ReactNode) => void;
}

const ComponentRegistryContext = createContext<ComponentRegistryContextType | undefined>(undefined);

export const ComponentRegistryProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [componentRegistry, setComponentRegistry] = useState<Record<string, ReactNode>>({});

    const registerComponent = useCallback((name: string, component: ReactNode) => {
        setComponentRegistry(prev => ({
            ...prev,
            [name]: component
        }));
    }, []);

    return (
        <ComponentRegistryContext.Provider value={{ componentRegistry, registerComponent }}>
            {children}
        </ComponentRegistryContext.Provider>
    );
};

export const useComponentRegistry = () => {
    const context = useContext(ComponentRegistryContext);
    if (!context) {
        throw new Error('useComponentRegistry must be used within ComponentRegistryProvider');
    }
    return context;
};